import { useCallback, useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../../App'
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Button,
  Tooltip,
} from '@mui/material'
import { Eye } from 'lucide-react'
import { BsFileMedical } from 'react-icons/bs'
import PrimeTable from '../../../../components/PrimeTable'
import AutoComplete from '../../../../components/AutoComplete/AutoComplete'
import Questionario from '../../../questionario/componente/Questionario'
import { setSuccess } from '../../../../components/alerts'
import { IoCloseSharp } from 'react-icons/io5'
import { metodoPrograma } from '../../../../components/api'
import { FaRegCopy } from 'react-icons/fa'

export const ListaQuestionario = ({ atendimentoSelecionado }) => {
  const { agenda } = useContext(GlobalContext)
  const [acQuestionario, setAcQuestionario] = useState(undefined)
  const [openModal, setOpenModal] = useState(false)
  const [openModalVisualizaResposta, setOpenModalVisualizaResposta] =
    useState(false)
  const [loading] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const [duplica, setDuplica] = useState(false)

  const [questionario, setQuestionario] = useState(undefined)
  const [questionarioResposta, setQuestionarioResposta] = useState(undefined)
  const [idRespostaDuplicada, setIdRespostaDuplicada] = useState(undefined)

  function duplicaFormulario(idResposta, idQuestionario) {
    setIdRespostaDuplicada(idResposta)
    setQuestionarioResposta({
      questionario: {
        idQuestionario,
      },
      resposta: { idResposta },
    })
    setDuplica(true)
    setOpenModalVisualizaResposta(true)
  }

  function visualizaFormulario(idResposta, idQuestionario) {
    setQuestionarioResposta({
      questionario: {
        idQuestionario,
      },
      resposta: { idResposta },
    })
    setDuplica(false)
    setOpenModalVisualizaResposta(true)
  }

  const exclui = useCallback((dados) => {
    metodoPrograma('excluiRespostaQuestionarioPaciente', {
      idResposta: dados[0],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  useEffect(() => {
    if (questionario?.resposta?.idResposta) {
      setSuccess('Resposta finalizada')
      setOpenModal(false)
      setAcQuestionario(undefined)
    }
    if (
      idRespostaDuplicada !== undefined &&
      questionarioResposta?.resposta?.idResposta !== idRespostaDuplicada
    ) {
      setSuccess('Resposta finalizada ok')
      setDuplica(false)
      setOpenModalVisualizaResposta(false)
      setIdRespostaDuplicada(undefined)
    }
    setRefresh((prev) => prev + 1)
  }, [questionario, questionarioResposta, idRespostaDuplicada])

  return (
    <Grid item xs={12}>
      <Grid container spacing={1}>
        <Grid item xs={9}></Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              setQuestionario(undefined)
              setOpenModal(true)
            }}
          >
            <BsFileMedical
              style={{
                fontSize: '20px',
                marginBottom: 5,
                marginTop: 5,
                marginRight: 20,
              }}
            />
            Novo Questionário
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <PrimeTable
          codigo="CtrlAtendimentoMedico"
          action="listaQuestionarioPaciente"
          refresh={refresh}
          parametros={{
            idPaciente: atendimentoSelecionado?.dadosAtendimento[7]?.idPaciente,
            idAgenda: agenda[0],
          }}
          habSearch={false}
          rows={10}
          head={['Questionário', 'Resposta', '']}
          line={(item) => [
            item[3],
            item[2],
            <>
              <Tooltip title="Visualizar formulário">
                <IconButton
                  key={item[0]}
                  onClick={() => visualizaFormulario(item[0], item[1])}
                >
                  <Eye size={18} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Duplicar formulário">
                <IconButton
                  key={item[0]}
                  onClick={() => duplicaFormulario(item[0], item[1])}
                >
                  <FaRegCopy size={18} />
                </IconButton>
              </Tooltip>
            </>,
          ]}
          collumnsDateHour={[1]}
          onDelete={{ index: 99, action: exclui }}
        />
      </Grid>
      <Dialog
        open={openModalVisualizaResposta}
        onClose={() => setOpenModalVisualizaResposta(false)}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle>
          {duplica ? 'Novo Questionário (duplicado)' : 'Visualizando Resposta'}
        </DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <Questionario
              questionario={questionarioResposta}
              setQuestionario={setQuestionarioResposta}
              dsNome={atendimentoSelecionado?.dadosAtendimento[7]?.nmPaciente}
              idPaciente={
                atendimentoSelecionado?.dadosAtendimento[7]?.idPaciente
              }
              disabled={!duplica}
              duplicar={true}
            />
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return
          setOpenModal(false)
        }}
        fullWidth
        disableEscapeKeyDown
        maxWidth="xl"
        fullScreen={questionario !== undefined}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          Novo Questionário
          <IconButton onClick={() => setOpenModal(false)} size="small">
            <IoCloseSharp fontSize={22} />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: questionario !== undefined ? 0 : 20 }}>
          {questionario !== undefined ? (
            <Grid item xs={12}>
              <Questionario
                questionario={questionario}
                setQuestionario={setQuestionario}
                dsNome={atendimentoSelecionado?.dadosAtendimento[7]?.nmPaciente}
                idPaciente={
                  atendimentoSelecionado?.dadosAtendimento[7]?.idPaciente
                }
              />
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <AutoComplete
                  metodo="buscaQuestionario"
                  codigo="CtrlAtendimentoMedico"
                  searchParams={{ idAgenda: agenda[0] }}
                  value={acQuestionario}
                  name="acQuestionario"
                  label="Escolha o Questionário"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  onChange={(_, val) => {
                    setAcQuestionario(val)
                  }}
                />
              </Grid>

              <Grid item xs={12} style={{ textAlign: 'right' }}>
                <Button
                  onClick={() =>
                    setQuestionario({
                      questionario: {
                        idQuestionario: acQuestionario?.[0]?.[0],
                      },
                      resposta: { idResposta: undefined },
                    })
                  }
                  variant="contained"
                  color="primary"
                  disabled={loading || !acQuestionario?.[0]?.[0]}
                  startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                  Aplicar Questionário
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  )
}
